var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DAA658"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.965 24c-.175-.038-.352-.064-.523-.114-1.094-.311-1.786-1.162-1.834-2.32-.05-1.195.08-2.374.53-3.494.292-.724.714-1.35 1.424-1.732.428-.233.91-.35 1.397-.337.154.003.317.082.458.159.228.125.438.28.66.417 1.284.8 2.568.798 3.853-.003.178-.112.36-.219.526-.346.307-.232.645-.26 1.01-.207.995.148 1.7.698 2.174 1.576.423.783.613 1.634.698 2.51.044.452.064.905.059 1.358-.016 1.351-.935 2.357-2.268 2.505a.584.584 0 0 0-.098.028h-8.066z",
    fill: "#101112"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.995 11.995c.007 2.204-1.77 3.986-3.993 4.005-2.193.018-3.995-1.775-4.006-3.99A4.004 4.004 0 0 1 15.99 8a3.999 3.999 0 0 1 4.007 3.995h-.001z",
    fill: "#101112"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.e6e88594c36d10569ce10774d39f1f25.svg";
export { ForwardRef as ReactComponent };